import { ref, onMounted, onBeforeUnmount } from 'vue';
import { emitter } from 'shared/helpers/mitt';
import kanbanAPI from 'dashboard/api/kanban';

// SiteUp: liga o popup de confirmação de agendamento WAHA ao evento global
// 'kanban:appointment:scheduled' (emitido pela camada da API sempre que um item
// é salvo com um compromisso, de QUALQUER tela — painel da conversa, card em tela
// cheia ou Agenda). Só abre se o toggle appointment_waha.enabled do Kanban estiver
// ligado (toggle OFF = só agenda/Google, sem WhatsApp). Cada componente que usa
// este composable monta seu próprio modal; as telas de origem são rotas
// mutuamente exclusivas, então nunca há dois modais montados ao mesmo tempo.
export function useKanbanAppointmentPopup() {
  const open = ref(false);
  const itemId = ref(null);
  const scheduledAt = ref('');

  const onScheduled = async payload => {
    const id = payload?.itemId;
    const sa = payload?.scheduledAt;
    if (!id) return;
    try {
      const cfg = await kanbanAPI.getAppointmentConfig();
      if (cfg && cfg.enabled === true) {
        itemId.value = String(id);
        scheduledAt.value = sa || '';
        open.value = true;
      }
    } catch (e) {
      // config indisponível: segue sem popup (o agendamento já foi salvo)
    }
  };

  onMounted(() => emitter.on('kanban:appointment:scheduled', onScheduled));
  onBeforeUnmount(() =>
    emitter.off('kanban:appointment:scheduled', onScheduled)
  );

  return { open, itemId, scheduledAt };
}
